import { FormErrorsProps } from '../../interfaces';
import { FormContextErrorActions } from './form-context-error-actions.type';

export const formContexErrorReducer = (
  state: FormErrorsProps,
  action: FormContextErrorActions
): FormErrorsProps => {
  switch (action.type) {
    case 'Add': {
      if (action.payload.errors == null || action.payload.errors.length < 1) {
        delete state[action.inputName];
        return { ...state };
      }
      return { ...state, [action.inputName]: action.payload };
    }
    case 'Remove': {
      delete state[action.inputName];
      return { ...state };
    }
    case 'Clean': {
      return Object.assign({});
    }
    default: {
      return state;
    }
  }
};
